export default __webpack_public_path__ + "static/media/8.aa28c22a.png";